// extracted by mini-css-extract-plugin
export default {"subMenuItem":"styles_subMenuItem__M5crx"};